export class NavItemModel {
  isActive: boolean = false;

  constructor(public routePath: string) {
  }

  matches(path: string): boolean {
    // I want to find the begin position and end position of all the path variables.
    const pathVariablesPositions: { start: number, end: number }[] = [];

    const pathParts = path.split('/');

    const routePathParts = this.routePath.split('/');

    let matches = undefined;

    for (let index = 0; index < routePathParts.length; index++) {
      const routePathPart = routePathParts[index];

      if (index >= pathParts.length) {
        matches = false;
        break;
      }

      if (routePathPart === '*') {
        matches = true;
        break;
      }

      // If route path part is a path variable, then we match for this turn. We must ensure we have the same number
      // of paths, else we'll always match our children. If we want to match our children, we have to use "*".
      if (routePathPart.startsWith(':') && routePathParts.length === pathParts.length) {
        matches = true;
        continue;
      }

      const pathPart = pathParts[index];

      // If there's no match, we exit and return matches = false.
      if (routePathPart != pathPart) {
        matches = false;
        break;
      }

    }

    if (matches === undefined) {
      return path === this.routePath;
    }

    return matches;
  }
}